import { StepType } from 'src/app/shared/shared.module';
import {
  getInputField, setAsRequired, setRegexValidation,
  getSelectField, getTelephoneField,MinMaxAgeMustBe, setYesNoValues, getArrayPickerField, setRequiredWhen, setDisableWhen
} from 'src/app/shared/form';
import { VisaType } from '../../visatypes';
import { FieldTooltip } from '../../field-tooltip.enum';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { map } from 'rxjs/operators';
import { nullSafe } from '../../../../../utils';


export class PassportInfoUpdate extends VisaType {


  GetRequesterSteps(operations?: () => string[]): StepType[] {

    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.EmpProfileSearch(null, operations),

            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.gpn(),
              this.gui()
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.firstName(),
              this.middleName(),
              this.lastName()
            ]
          },
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.nationalityTypeWithSpecialExpact(),  
              this.nationality(),
              getSelectField(
                "specialExpat",
                "Special expat",
                setYesNoValues(this.common.getSpecialExpactWrtNationalityType(setAsRequired(this.AddTooltipToControl(FieldTooltip.KSASpecialExpat)))
              )),
              this.passportNumber(),
              this.dateOfBirth(MinMaxAgeMustBe(10, 100, 'Date of birth cannot be in the past 10 years or in the future')),       
              getSelectField(
                "serviceLine.id",
                "Service line",
                this.common.getSelectFieldOptions(this.serviceLines$, '',
                  setAsRequired())
              ),
              getSelectField(
                "subServiceLine.id",
                "Sub-service line",
                this.common.getSelectFieldOptions(this.subServiceLines$, "serviceLine.id",
                  setAsRequired())
              ),
              this.rank(),      
              getTelephoneField(
                "Mobile number (KSA)",
                this.common.ValidateCountryCode("+966",setAsRequired({ wrappers: ['no-harm-error'] })),'col-md-4  pr-0 '),
                this.officeLocation(),   
                this.officeLE('EY legal entity'),    
              getSelectField(
                "wantToUpdateDependentPassport.id",
                "Would you like to update your dependent's passport information?",
                this.common.getSelectFieldOptions(this.yesNo$, '',
                  setAsRequired({ className: 'col-md-4 mb-3 text-sm lengthy-label' }))
              ),
              getArrayPickerField('dependentDetails', 'Dependent details', this.DependentDetails('dependent'), 'dependent',
                setRequiredWhen((model) => {
                  return nullSafe(() => model.wantToUpdateDependentPassport.id === 1074, false);
                })),

              this.RequestorName(),
       
            ]
          }]
      }
    ];

  }


  GetAccepterSteps(): StepType[] {
    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.visaProcessorByOfficeLE(setAsRequired()),
              // this.Requestor()
            ]
          }
        ]
      }
    ];
  }

  GetApproverSteps(): StepType[] {

    return [
      {
        label: "Step 1",
        fields: [
          {
            fieldGroupClassName: "row",
            fieldGroup: [
              this.visaProcessorByOfficeLE(
                setAsRequired()
                ),
              this.immigrationStatus(),
              // this.Requestor()
            ]
          }
        ]
      }
    ];
  }


  private DependentDetails(_buttonAddText: string): FormlyFieldConfig[] {
    return (
      [
        {
          key: 'formData',
          type: 'repeat',
          templateOptions: {
            addText: `Add ${_buttonAddText}`,
          },
          fieldGroupClassName: "row",
          fieldArray: {
            fieldGroup: [
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  getInputField(
                    "firstName",
                    "First name (as per passport)",
                    // tslint:disable-next-line: max-line-length
                    setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                  ),
                  getInputField(
                    "middleName",
                    "Middle name (as per passport)",
                    setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' })
                  ),
                  getInputField("lastName", "Last name (as per passport)",
                    // tslint:disable-next-line: max-line-length
                    setAsRequired(setRegexValidation(/^[a-zA-Z -]*$/, 'Please enter a valid name', { className: 'col' }))
                  ),
                ]
              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                 
                  getSelectField(
                    "relationship.id",
                    "Relationship",
                    this.common.getSelectFieldOptions(
                      this.relationship$.pipe(map(item => item.filter(i => [9007, 9008].includes(i.id)))), '',
                      setAsRequired())
                  ),
                  this.dateOfBirth(this.common.validateDOBOnRelationship(
                    'relationship.id')),
                  this.gender()

                ]
              },
              {
                fieldGroupClassName: "row",
                fieldGroup: [
                  this.nationality(),
                  getInputField("passportNumber", "Passport number", setAsRequired({ className: 'col-md-4 mb-3' })),
                  this.passportExpiryDate('Passport expiry date'),
                  getInputField("iqamaId", "Iqama ID", setAsRequired({ className: 'col-md-4 mb-3' })),
                  this.nationalityType(),
                ]
              }


            ]
          },
        },
      ]
    );
  }

}
